export default __webpack_public_path__ + "static/media/logo_google.48fbb702.svg";